import { useState } from "react";
import "../../assets/css/product.scss";

import closeSvg from "../../assets/images/icons/close.svg";
import defenceSvg from "../../assets/images/icons/defence.svg";
import { requestPhoneAuth, verifyPhoneCode } from "../../api/auth";
import { SessionStorageUtil } from "../../utils/session_storage_util";

function ProductAuthModal({ isOpen, onClose, onSuccess }) {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [authNumber, setAuthNumber] = useState("");
  const [isVerifyInput, setIsVerifyInput] = useState(false);

  const phoneNumberChange = (e) => {
    handleNumberInputChange(e, setPhoneNumber);
  };

  const authNumberChange = (e) => {
    handleNumberInputChange(e, setAuthNumber);
  };

  const handleNumberInputChange = (e, setter) => {
    const inputValue = e.target.value;
    if (/^\d*$/.test(inputValue)) {
      setter(inputValue);
    }
  };

  const validate = () => {
    if (!isValidPhoneNumber()) {
      return false;
    }
    if (!authNumber || authNumber.trim() === "") {
      alert("인증번호를 입력해주세요.");
      return false;
    }

    return true;
  };

  const isValidPhoneNumber = () => {
    const phoneRegex = /^01[016789]\d{7,8}$/;

    if (!phoneNumber || phoneNumber.trim() === "") {
      alert("휴대폰번호를 입력해주세요.");
      return false;
    }
    if (!phoneRegex.test(phoneNumber)) {
      alert("유효한 휴대폰 번호 형식이 아닙니다.");
      return false;
    }
    return true;
  };

  const reset = () => {
    setPhoneNumber("");
    setAuthNumber("");
    setIsVerifyInput(false);
  };

  if (!isOpen) return null;

  return (
    <div className="product-auth-modal modal-wrap">
      <div
        className="overlay"
        onClick={() => {
          reset();
          onClose();
        }}
      >
        <div className="modal" onClick={(e) => e.stopPropagation()}>
          <div>
            <button
              className="closeBtn"
              onClick={() => {
                reset();
                onClose();
              }}
            >
              <img src={closeSvg} alt="" />
            </button>
          </div>
          <ul className="content">
            <li>
              <img src={defenceSvg} alt="" />
            </li>
            <li>휴대폰 인증</li>
            <li>휴대폰 번호</li>
            <li>
              <div className="input-with-button">
                <input
                  type="text"
                  value={phoneNumber}
                  onChange={phoneNumberChange}
                  placeholder="“-”없이 숫자만 입력"
                />
                <button
                  onClick={async () => {
                    if (isValidPhoneNumber()) {
                      console.log("요청 성공");
                      const res = await requestPhoneAuth(phoneNumber);

                      setIsVerifyInput(res.success);
                    }
                  }}
                >
                  인증요청
                </button>
              </div>
            </li>
            <li style={{ display: isVerifyInput ? "block" : "none" }}>
              인증번호
            </li>
            <li style={{ display: isVerifyInput ? "block" : "none" }}>
              <input
                type="text"
                value={authNumber}
                onChange={authNumberChange}
                placeholder="인증번호를 입력하세요"
              />
            </li>
            <li>
              <button
                onClick={async () => {
                  if (validate()) {
                    const res = await verifyPhoneCode(phoneNumber, authNumber);

                    if (res.success === true) {
                      alert("인증이 완료 되었습니다.");
                      SessionStorageUtil.setItem("phoneNumber", phoneNumber);
                      SessionStorageUtil.setItem(
                        "accessToken",
                        res.data.accessToken
                      );
                      onSuccess && onSuccess(phoneNumber);
                      reset();
                    }
                  }
                }}
              >
                인증완료
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ProductAuthModal;
